import React from 'react';

const StandardHeader = ({
    icon,
    title, 
    subtitle, 
    customActions = null,
    additionalStats = null 
}) => {
    const styles = {
        header: {
            backgroundColor: '#1a1a1a',
            borderBottom: '2px solid #333',
            padding: '25px',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            boxShadow: '0 2px 10px rgba(0,0,0,0.5)'
        },
        headerContent: {
            maxWidth: '1400px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '20px'
        },
        titleSection: {
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            flex: 1
        },
        title: {
            fontSize: '28px',
            fontWeight: 'bold',
            color: '#f8f1e4',
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            fontFamily: "'BlackFuture', sans-serif",
            letterSpacing: '0.05em',
        },
        subtitle: {
            fontSize: '16px',
            color: '#ccc',
            margin: 0        },
        headerActions: {
            display: 'flex',
            gap: '12px',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        statsContainer: {
            display: 'flex',
            gap: '20px',
            alignItems: 'center',
            fontSize: '14px',
            color: '#ccc',
            marginTop: '10px'
        },
        statItem: {
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            padding: '5px 10px',
            backgroundColor: '#333',
            borderRadius: '12px',
            fontSize: '12px'
        }
    };

    return (
        <header style={styles.header}>
            <div style={styles.headerContent}>
                <div style={styles.titleSection}>
                    <h1 style={styles.title}>
                        {icon} {title}
                    </h1>
                    <p style={styles.subtitle}>
                        {subtitle}
                    </p>
                    {additionalStats && (
                        <div style={styles.statsContainer}>
                            {additionalStats}
                        </div>
                    )}
                </div>
                  <div style={styles.headerActions}>
                    {customActions}
                </div>
            </div>
        </header>
    );
};

export default StandardHeader;
